import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";

import ErorrIcon from "assets/icons/404Figma.svg";

const Error404 = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "background.default",
      }}
    >
      <Box component="img" src={ErorrIcon} alt="404 Error" />

      <Typography
        variant="h4"
        color="text.primary"
        textAlign="center"
        sx={{ mb: 2 }}
      >
        The page you requested could not be found.
      </Typography>

      <Typography
        variant="body1"
        component={Link}
        to="/orders"
        sx={{
          textDecoration: "none",
          color: "primary.main",
          "&:hover": { textDecoration: "underline" },
        }}
      >
        Back to Dashboard
      </Typography>
    </Box>
  );
};

export default Error404;
